const MESSAGES: ReadonlyMap<RecaptchaTokenError['reason'], string> = new Map([
  ['empty-token', 'reCAPTCHA returned an empty token'],
  ['execute-failed', 'Failed to execute reCAPTCHA'],
  ['script-load-failed', 'Failed to load reCAPTCHA script'],
  ['site-key-missing', 'reCAPTCHA site key is not configured'],
  ['timeout', 'reCAPTCHA verification timed out']
])

// A token could not be obtained; the submit that needed it must not reach the API.
export class RecaptchaTokenError extends Error {
  public readonly reason:
    'empty-token' | 'execute-failed' | 'script-load-failed' | 'site-key-missing' | 'timeout'

  public constructor(reason: RecaptchaTokenError['reason'], options?: { cause: unknown }) {
    super(MESSAGES.get(reason) ?? reason, options)
    this.name = 'RecaptchaTokenError'
    this.reason = reason
  }
}
